/**
 * Class element
 * Header component
 * Display the header
 */
/* Import section */
import { Link } from "gatsby"
import React, { Component } from "react"
import { IconContext } from "react-icons"
import { BsFillCircleFill, BsArrowClockwise, BsBookHalf } from "react-icons/bs"
import Logo from "../components/logo"
import "../styles/components/header.scss"

/* Declaration class */
class Header extends Component {

  constructor() {
    super()
    this.state = {
      width: 0,
      newRelease: true
    }
  }

  componentDidMount() {
    this.handleWindowSizeChange()
    window.addEventListener('resize', this.handleWindowSizeChange)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    if(window.innerWidth !== this.state.width) {
      this.setState({
        width: window.innerWidth,
        newRelease: this.state.newRelease
      })
    }
  }

  openModal() {
    this.setState({
      width: window.innerWidth,
      newRelease: this.state.newRelease
    })

    document.body.style.overflow = 'hidden'
    var modal = [].slice.call((document.getElementsByClassName("modal-releasenotes")))
    modal[0].classList.remove("hidden")
  }

  render () {

    return (
      <header className="main-header">
        <div className="wrap-maincontent">
          <div className="main-logo">
            <Link className="link-logo" to="/">
              <Logo />
            </Link>
          </div>
          <div className="main-nav">
            <a className="access-onlinelibrary" href="https://knowledge.hellohealth.com/knowledge" target="_blank" rel="noreferrer">
              <span className="icon-nav">
                <IconContext.Provider value={{ className: "svg-nav" }}>
                  <i aria-hidden="true"><BsBookHalf /></i>
                </IconContext.Provider>
              </span >
              Online Library
            </a>
            <span className="separator"></span>
            <button className="button-open-modal" aria-label="Open the modal" onClick={() => this.openModal()}>
              <span className="icon-nav">
                <IconContext.Provider value={{ className: "svg-nav" }}>
                  <i aria-hidden="true"><BsArrowClockwise /></i>
                </IconContext.Provider>
              </span >
              Product Updates
              {this.state.newRelease &&
                <sup>
                  <IconContext.Provider value={{ className: "svg-point" }}>
                    <i aria-hidden="true"><BsFillCircleFill /></i>
                  </IconContext.Provider>
                </sup>
              }
            </button>

          </div>

        </div>
      </header>
    )
  }
}

/* Export class */
export default Header
